/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButtonClose/view.blocks to change it.
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaButtonClose({
  children,
  viewPath = "/DesignSystem/TysiaButtonClose",
  type = "secondary",
  onClick,
  alignSelf,
  fill
  
}) {
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type={type}
 size="small"
 title="Close"
 onClick={onClick}
 alignSelf={alignSelf}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={fill}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={onClick}
/>
{children}
</React.Fragment>)
}